<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        Delegate Members
        <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content>
    <div class="notification">
        <p style="margin-left: 2%;font-style: italic;padding-top: 5px;padding-bottom: 5px;"><strong>Note :-</strong> There are ongoing documents for which the following members are assigned to roles that are now inactived.<strong>Therefore kindly provide a delegate member.</strong>  
        </p>
    </div>
    <br>
    <kendo-grid [kendoGridBinding]="ReplacementRequiredMembers" class="eip-pb-20 k-resizable-grid" [sortable]="false" [resizable]="false" [reorderable]="false" [pageable]="false" id="grvStatusList" [resizable]="true">
        <kendo-grid-column title="Sl.No." filterable="false" [width]="35">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{rowIndex+1}}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Member" field="member_Name" [width]="130">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.member_Name}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.member_Name}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Role" field="roleDesc" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span eipTooltip="{{dataItem.roleDesc}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.roleDesc}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Delegate For *"  [width]="130">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div class="fs-12 ff-2 eip-pr-10">  
                    <EIPAutoComplete ShowTextValueField='N' setId="replaceby{{rowIndex}}" floatLabelOption="never" TextField="memberName"  ValueField="memberId"  [IsCascading]='true' [dataSource]='dataItem.ReplacementMembers' formControlName="replaceby{{rowIndex}}" [SingleValueBind]="false" required (valueChange)="UpdateValueChange($event,dataItem,rowIndex)" [defaultValue]="dataItem.replaceMemberId">
                    </EIPAutoComplete>
                    <mat-error *ngIf="(dataItem.replaceMemberId == '0') || (dataItem.replaceMemberId == '-2')" style="margin-top: -17px; font-size: 75%;font-size: smaller;font-weight: bold;">Value Required !!!</mat-error>
                </div>                        
            </ng-template>
        </kendo-grid-column>      
    </kendo-grid>
</div>
<div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">
        <button (click)="DelegateMember()" class="btn btn-primary" type="submit" id="btnEDMSave" [disabled]="isValid()"><i class="fa fa-delegated-access" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Delegate & Update</button>&nbsp;
        <button (click)="closeDialog()" class="btn btn-secondary" id="btnEDMCancel"><i class="fa fa-ban" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Cancel</button>
    </div>
</div>